import { createSelectors } from '@mri-platform/shared/entity';
import { AccessToken } from '../../models';

export const accessTokenSelectors = createSelectors(AccessToken);
